var map = {
	"./slot_atg.png": "2945",
	"./slot_bbin.png": "3f07",
	"./slot_cq9.png": "ad34",
	"./slot_fachai.png": "cb2a",
	"./slot_funta.png": "e196",
	"./slot_gamex.png": "91ba",
	"./slot_jdb.png": "544f",
	"./slot_jili.png": "0618",
	"./slot_ka.png": "efb1",
	"./slot_migame.png": "0600",
	"./slot_pg.png": "948d",
	"./slot_pp.png": "580f",
	"./slot_ps.png": "c862",
	"./slot_rich.png": "1844",
	"./slot_spd.png": "96e0",
	"./slot_t1.png": "b535"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ed66";